import React from 'react'
import"./css/header.css";
import SearchIcon from '@material-ui/icons/Search';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { Link } from 'react-router-dom';
/* import { Categories } from '@chec/commerce.js/features/categories'; */
/* import LocationOnIcon from '@material-ui/icons/LocationOn';
import LanguageIcon from '@material-ui/icons/Language'; */


const Header = ({cart , categoryList}) => {
    return (
        <>
        <div className="header">
            <Link to="/">
            <img src="http://www.userlogos.org/files/logos/ArkAngel06/Amazon.png" className="header__logo" alt="" />
            </Link>
           {/*  <div className="header__optionBasket">
                       
                        <LocationOnIcon/>
                        <span>
                            Delivered to User
                        </span>
                       
            </div> */}
            <div className="header__search">
                <input type="text" />
                <SearchIcon className="header__searchIcon"/>
            </div> 
           {/*  <div className="header__optionBasket">
                       <LanguageIcon/>
                       <span className="header__optiontwo" >Language </span>
            </div> */}
            <div className="header__nav">
                <div className="header__option">
                    <span className="header__optionone">Hello Rishav </span>
                    <span className="header__optiontwo">Sign In </span>
                </div>

                <div className="header__option">
                    <span className="header__optionone">Returns</span>
                    <span className="header__optiontwo">&Orders </span>
                </div>

                <div className="header__option">
                    <span className="header__optionone">Your</span>
                    <span className="header__optiontwo">Prime </span>
                </div>
                    <div className="header__optionBasket">
                        <Link to="/cart">
                        <ShoppingCartIcon/>
                        <span>
                            {cart?.total_items}
                        </span>
                        </Link>
                    </div>

            </div>
       
        </div>
        <div className="header__bottom">
            <ul>
                {
                    categoryList?.map(category=>{
                        return( <li key={category.id}>
                            <Link to={`/category/${category.slug}`}>
                            {category.name}
                            </Link>
                            </li>
                        )
                        })
                }
             
               
                <li>
                    <img src="https://d2908q01vomqb2.cloudfront.net/9e6a55b6b4563e652a23be9d623ca5055c356940/2018/01/22/Appstream2.0.png" alt="" />
                </li>
            </ul>
        </div>
        </>
    )
}

export default Header
 